export default __webpack_public_path__ + "static/media/add-house.8f6bd9ff.png";